import { appConfig, headerConfig, refineHeader } from "../../config";

export const categoryService = {
  addCategory,
  getCategory,
  statusCategory,
  deleteCategory,
  getCategoryById,
  getCategoryDetail,
  updateCategory,
  uploadPhoto,
  getAllCategory,
  getParentCategories,
  getSubCategories
};

function addCategory(data) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(`${appConfig.api.url}category/add`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function uploadPhoto(data) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(`${appConfig.api.url}file`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function updateCategory(data) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(`${appConfig.api.url}category/edit`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getCategory(formdata) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formdata)
  };

  return fetch(`${appConfig.api.url}category/list`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getCategoryById(parentID, page, search, limit) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify({ parentID, page, search, limit})
  };

  return fetch(`${appConfig.api.url}category/sub-category`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getCategoryDetail(catID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas
  };

  return fetch(`${appConfig.api.url}category/detail/${catID}`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getAllCategory(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}category/all`, requestOptions)
    .then(handleResponse)
    .then(allcategory => {
      return allcategory;
    });
}

function statusCategory(catID, status) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    body: JSON.stringify({ catID, status })
  };

  return fetch(`${appConfig.api.url}category/status`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function deleteCategory(catID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas
  };

  return fetch(`${appConfig.api.url}category/delete/${catID}`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getParentCategories() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas
  };

  return fetch(`${appConfig.api.url}category/parent-list`, requestOptions)
    .then(handleResponse)
    .then(pcategory => {
      return pcategory;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
 
function getSubCategories(parentID, sub_cat_id) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify({ parentID, sub_cat_id })
  };

  return fetch(`${appConfig.api.url}category/second-sub-category`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/API/categoryService.js